import React, { useEffect, useRef } from 'react';
import { skills } from '../../data/portfolioData';
import './Skills.css';

const Skills = () => {
  const categoryRefs = useRef([]);

  useEffect(() => {
    const observers = categoryRefs.current.map((el, i) => {
      if (!el) return null;
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setTimeout(() => el.classList.add('visible'), i * 120);
            observer.disconnect();
          }
        },
        { threshold: 0.2 }
      );
      observer.observe(el);
      return observer;
    });
    return () => observers.forEach(o => o && o.disconnect());
  }, []);

  return (
    <section className="skills-section" id= "skills">
      <div className="section-header">
        <span className="section-tag">TECH STACK</span>
        <h2>Skills & Tools</h2>
        <p>Technologies and tools I work with daily</p>
      </div>
      <div className="skills-grid">
        {Object.entries(skills).map(([category, items], index) => (
          <div
            key={category}
            className="skill-category"
            ref={el => categoryRefs.current[index] = el}
          >
            <h3>{category}</h3>
            <div>
              {items.map((skill, i) => (
                <span key={i} className="skill-tag">{skill}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Skills;
